import { Grid } from "@mui/joy";
import NewsCard from "./NewsCard";

function NewsList({ articles }) {
  return (
    <Grid container>
      {articles.map((article) => (
        <NewsCard key={article.id} article={article} />
      ))}
    </Grid>
  );
}

export default NewsList;